// extracted by mini-css-extract-plugin
module.exports = {"results":"Results__results--2OxcE","resultItem":"Results__resultItem--33Qo3","resultLink":"Results__resultLink--FeIEq","resultLinkAll":"Results__resultLinkAll--Ilsdn","resultIcon":"Results__resultIcon--2SnX0","resultTitle":"Results__resultTitle--jIcdh","quickLinksWrapper":"Results__quickLinksWrapper--MKGs4","quickLink":"Results__quickLink--5Ygqs"};
    if(module.hot) {
      // 1571674791220
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  